import { GenericRule } from '../../../../../../../utils/genericValidator.util';
import { AvailabilityEnum } from '../../../../../../products/ProductTypes';
import { isPreOrderOrMaterial } from '../../../../../../products/utils/availability.utils';
import { OfflineOrderProduct } from '../../OfflineOrderProduct';

export class ValidateAvailabilityLength implements GenericRule<OfflineOrderProduct> {
  validateOrThrow(orderProduct: OfflineOrderProduct) {
    if (
      this.isPreOrderValid(orderProduct) ||
      this.isFutureStockValid(orderProduct) ||
      this.isReadyForDeliveryValid(orderProduct) ||
      this.isEmptyValid(orderProduct)
    ) {
      return;
    }

    throw new Error('invalid availability');
  }

  private isPreOrderValid(orderProduct: OfflineOrderProduct) {
    return (
      isPreOrderOrMaterial(orderProduct.availability) &&
      orderProduct.deliveryWindow &&
      orderProduct.grid.some((gridItem) =>
        gridItem.sku.preOrderDeliveryWindowIds?.includes(orderProduct.deliveryWindow!.id),
      )
    );
  }

  private isFutureStockValid(orderProduct: OfflineOrderProduct) {
    return (
      orderProduct.availability === AvailabilityEnum.FUTURE_STOCK &&
      orderProduct.deliveryWindow &&
      orderProduct.grid.some((gridItem) => {
        const isProductColorIdValid =
          gridItem.futureStock?.productColorId === orderProduct.productColor.id;

        const isDeliveryWindowIdValid =
          gridItem.futureStock?.deliveryWindowId === orderProduct.deliveryWindow!.id;

        return isProductColorIdValid && isDeliveryWindowIdValid;
      })
    );
  }

  private isReadyForDeliveryValid(orderProduct: OfflineOrderProduct) {
    return (
      orderProduct.availability === AvailabilityEnum.READY_FOR_DELIVERY &&
      !orderProduct.deliveryWindow &&
      orderProduct.grid.some((gridItem) => gridItem.stock)
    );
  }

  private isEmptyValid(orderProduct: OfflineOrderProduct) {
    return (
      orderProduct.availability === AvailabilityEnum.EMPTY &&
      !orderProduct.deliveryWindow &&
      orderProduct.grid.every((gridItem) => gridItem.quantity === 0)
    );
  }
}
